import { isNil } from 'lodash';
import { ReactNode } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBChannelImage } from '@shared/components/image';
import { Colors, grid } from '@shared/styles';
import { API } from '@shared/types/api';
import { formatChannelNameForDisplay } from '@shared/util/emoji';

interface MBBaseChatBannerProps {
  channel: API.ChannelFragment;
  title?: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
}

export function MBBaseChatBanner({
  channel,
  title = formatChannelNameForDisplay(channel),
  subtitle,
  children,
}: MBBaseChatBannerProps) {
  return (
    <View paddingVertical={3}>
      <View
        padding={3}
        paddingTop={2.5}
        style={{
          backgroundColor: Colors.v2.green10,
          borderWidth: 1,
          borderColor: Colors.v2.green,
          borderRadius: grid(1),
        }}
      >
        <View row>
          <MBChannelImage channel={channel} />
          <View flex centerVertically style={{ minHeight: grid(6) }} paddingLeft={2}>
            <View>
              <Text size="subtitle" color={Colors.v2.greenSecondary90}>
                {title}
              </Text>
            </View>
            {!isNil(subtitle) && (
              <View paddingTop={0.25}>
                <Text color={Colors.v2.greenSecondary90}>{subtitle}</Text>
              </View>
            )}
          </View>
        </View>
        {!isNil(children) && <View paddingTop={2}>{children}</View>}
      </View>
    </View>
  );
}
